import React from 'react';
import { CheckCircle, AlertTriangle, XCircle, Clock, Wrench, FileText, Calendar, Lock } from 'lucide-react';
import Icon from '@/components/ui/AppIcon';


type StatusVariant =
  | 'in-stock' | 'low-stock' | 'out-of-stock' | 'submitted' | 'in-progress' |'awaiting-signature' | 'draft' | 'pdf-generated' | 'pending' | 'completed'
  | 'scheduled' | 'closed';

interface StatusBadgeProps {
  status: StatusVariant;
  size?: 'sm' | 'md';
}

const statusConfig: Record<StatusVariant, { label: string; className: string; Icon: React.ElementType }> = {
  'in-stock': { label: 'In Stock', className: 'badge-success', Icon: CheckCircle },
  'low-stock': { label: 'Low Stock', className: 'badge-warning', Icon: AlertTriangle },
  'out-of-stock': { label: 'Out of Stock', className: 'badge-danger', Icon: XCircle },
  'submitted': { label: 'Submitted', className: 'badge-success', Icon: CheckCircle },
  'in-progress': { label: 'In Progress', className: 'badge-info', Icon: Wrench },
  'awaiting-signature': { label: 'Awaiting Sig.', className: 'badge-warning', Icon: Clock },
  'draft': { label: 'Draft', className: 'badge-muted', Icon: FileText },
  'pdf-generated': { label: 'PDF Ready', className: 'badge-success', Icon: FileText },
  'pending': { label: 'Pending', className: 'badge-warning', Icon: Clock },
  'completed': { label: 'Completed', className: 'badge-success', Icon: CheckCircle },
  'scheduled': { label: 'Scheduled', className: 'badge-info', Icon: Calendar },
  'closed': { label: 'Closed', className: 'badge-muted', Icon: Lock },
};

export default function StatusBadge({ status, size = 'md' }: StatusBadgeProps) {
  const config = statusConfig[status];
  if (!config) return null;
  const { label, className, Icon } = config;
  return (
    <span className={`badge ${className} ${size === 'sm' ? 'text-xs px-1.5 py-0.5' : ''}`}>
      <Icon size={size === 'sm' ? 10 : 12} />
      {label}
    </span>
  );
}